import React from 'react';
import { Reveal } from './ui/Reveal';
import { modulos } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="solucion" className="bg-carbon" data-id="element-146" data-mp="3gjawupa4iwbs">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-147" data-mp="3bidi6mobokf1">
        <Reveal className="text-center" data-id="element-148" data-mp="3bkpxst6lyiox">
          <h2 id="solucion" className="mx-auto max-w-3xl font-display text-2xl uppercase leading-none tracking-wide text-cream sm:text-4xl" data-id="element-149" data-mp="36kldes2kx3tf">
            La solución que estabas buscando —{' '}
            <span className="text-coral" data-id="element-150" data-mp="2wsfq3vn9vakk">un sistema 6 en 1</span>
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-cream sm:text-base" data-id="element-151" data-mp="2stglkc5gdftn">
            6 módulos en un solo sistema, creados para aprender a entrenar tu
            tren inferior desde las bases.
          </p>
          <p className="mt-1 font-display text-lg uppercase tracking-wide text-coral sm:text-2xl" data-id="element-152" data-mp="2itprgbkt12u3">
            🔥 SISTEMA LOWER BODY 360°
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-[0.78rem] leading-snug text-muted sm:text-sm" data-id="element-153" data-mp="13zhqn5wtd9zu">
            No es simplemente otro ebook de rutinas. Es un sistema de
            entrenamiento que organiza los conocimientos fundamentales para que
            comprendas qué hacer, cómo hacerlo, cómo estructurar tus sesiones y
            cómo progresar con mayor claridad.
          </p>
        </Reveal>

        <ol className="mt-3.5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-154" data-mp="1mp65zqo6mhu3">
          {modulos.map((modulo, i) => <Reveal key={modulo.label} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-nude/20 border-t-4 border-t-coral bg-carbon-soft p-3.5" data-id="element-155" data-mp="1rnr6zsb9d5jl" data-mpi={i}>
              <span className="self-start rounded bg-coral px-2 py-0.5 font-display text-[0.7rem] uppercase tracking-widest text-cream sm:text-xs" data-id="element-156" data-mp="1hspeqnlorncs">
                {modulo.label}
              </span>
              <h3 className="mt-1.5 font-display text-base uppercase leading-tight tracking-wide text-gold sm:text-lg" data-id="element-157" data-mp="693899hxzurk">
                {modulo.title}
              </h3>
              <p className="mt-1 text-[0.78rem] leading-snug text-beige sm:text-[0.82rem]" data-id="element-158" data-mp="23zjucjmd61dz">
                {modulo.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}